import React from "react";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaPhone,
  FaClock,
  FaGlobe,
  FaEnvelope,
  FaHeart,
} from "react-icons/fa";

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
        color: "white",
        padding: "30px 0 20px",
        marginTop: "auto",
      }}
    >
      <div className="container">
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-12 col-md-4">
            <div className="d-flex align-items-center mb-3">
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <FaBuilding style={{ fontSize: "20px", color: "white" }} />
              </div>
              <div>
                <h5 style={{ margin: 0, fontWeight: "700", fontSize: "16px" }}>
                  Tech Virtue Solutions
                </h5>
                <small style={{ color: "#a0a0a0" }}>
                  Software Company in Indore
                </small>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="col-12 col-md-4">
            <div className="d-flex">
              <FaMapMarkerAlt
                style={{ color: "#667eea", marginRight: "10px", marginTop: "3px" }}
              />
              <p style={{ margin: 0, fontSize: "13px", color: "#a0a0a0", lineHeight: "1.6" }}>
                Krishna Classic Tower, 304, AB Rd, above Axis Bank, near Sanjeevni Nursing Home, RK Puram, Indore, MP 452011
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="col-12 col-md-4">
            <div className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center">
                <FaPhone style={{ color: "#38ef7d", marginRight: "10px" }} />
                <a
                  href="tel:09770366571"
                  style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "14px" }}
                >
                  097703 66571
                </a>
              </div>
              <div className="d-flex align-items-center">
                <FaClock style={{ color: "#f5af19", marginRight: "10px" }} />
                <span style={{ color: "#a0a0a0", fontSize: "14px" }}>
                  <span style={{ color: "#f5576c" }}>Closed</span> · Opens 10:30 AM Mon
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <hr style={{ borderColor: "rgba(255,255,255,0.1)", margin: "20px 0 15px" }} />
        
        <div className="text-center">
          <p style={{ margin: 0, color: "#a0a0a0", fontSize: "13px" }}>
            © {new Date().getFullYear()}{" "}
            <span style={{ color: "#667eea", fontWeight: "600" }}>
              Tech Virtue Solutions
            </span>{" "}
            · Made with <FaHeart style={{ color: "#f5576c", fontSize: "12px" }} /> in Indore
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;